// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__16KuN","label":"Radio_label__2LQn_","checkMark":"Radio_checkMark__1ev60","disabled":"Radio_disabled__1-CTC"};